import { EVENT_FOCUS_IN, EVENT_FOCUS_OUT } from '@playgame/constants'
import { usePlaygameState, usePlaygameLogger } from '#imports'

export const usePlaygameEventTrigger = () => {
    const { games } = usePlaygameState()
    const playgameLogger = usePlaygameLogger()

    const _getGame = (identifier: string) => {
        return games.value.get(identifier)
    }

    const eventTrigger = async (identifier: string, eventType: string, eventPayload?: any) => {
        playgameLogger({ identifier, eventType, eventObject: eventPayload, direction: 'outbound' })

        const game = _getGame(identifier)
        if (!game) {
            console.warn(`Game with identifier ${identifier} not found`)
            return
        }

        switch (eventType) {
            // Panel State
            case EVENT_FOCUS_IN:
                game.focused = true
                break

            case EVENT_FOCUS_OUT:
                game.focused = false
                break
        }

        if (!game.gameWrapper) return

        await game.gameWrapper.trigger(eventType, eventPayload)
    }

    return {
        eventTrigger
    }
}
